import React from "react";
import { Link } from "react-router-dom";
import { KeyRound, Trash2, Shield } from "lucide-react";
import { deleteRole } from "../api/roleApi";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Table,
  Badge,
  IconButton,
  EmptyState,
} from "./ui";

const CATEGORY_BADGE_VARIANTS = {
  STAFF: "primary",
  STUDENT: "info",
  PARENT: "warning",
};

const RoleTable = ({ roles = [], refreshRoles }) => {
  const handleDelete = async (id) => {
    const confirmed = window.confirm("Delete this role?");
    if (!confirmed) return;

    try {
      await deleteRole(id);
      refreshRoles();
    } catch (error) {
      alert(error?.response?.data?.message || "Delete failed");
    }
  };

  const columns = [
    {
      key: "roleName",
      header: "Role Name",
      render: (role) => (
        <span className="font-semibold text-neutral-900 dark:text-neutral-100 text-xs sm:text-sm">
          {role.roleName}
        </span>
      ),
    },
    {
      key: "category",
      header: "Category",
      render: (role) => (
        <Badge
          variant={CATEGORY_BADGE_VARIANTS[role.category] || "default"}
          className="text-[11px]"
        >
          {role.category}
        </Badge>
      ),
    },
    {
      key: "actions",
      header: "Actions",
      align: "right",
      nowrap: true,
      render: (role) => (
        <div className="flex items-center justify-end gap-1.5">
          <Link to={`/roles/${role._id}`}>
            <IconButton
              type="button"
              variant="ghost"
              size="sm"
              title="Manage Permissions"
            >
              <KeyRound className="h-4 w-4 text-primary-600 dark:text-primary-400" />
            </IconButton>
          </Link>

          <IconButton
            type="button"
            variant="ghost"
            size="sm"
            onClick={() => handleDelete(role._id)}
            title="Delete Role"
          >
            <Trash2 className="h-4 w-4 text-danger-600" />
          </IconButton>
        </div>
      ),
    },
  ];

  return (
    <Card>
      <CardHeader className="border-b bg-neutral-50/50">
        <div className="flex items-center justify-between">
          <CardTitle className="flex items-center gap-2">
            <Shield className="h-5 w-5 text-neutral-700 dark:text-neutral-200 shrink-0" />
            <span>Defined System Roles</span>
          </CardTitle>
          <Badge variant="secondary" className="text-[11px]">
            Total: {roles.length}
          </Badge>
        </div>
      </CardHeader>

      <CardContent className="p-0">
        <Table
          columns={columns}
          data={roles}
          emptyState={
            <EmptyState
              icon={Shield}
              title="No roles created"
              description="Get started by defining a new system role using the form."
            />
          }
        />
      </CardContent>
    </Card>
  );
};

export default RoleTable;